import { Component, OnInit, Input, Output, OnChanges, Renderer2, Inject, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { PotentialJobsWorkingCommentsService } from 'src/app/service/potential-jobs-working-comments/potential-jobs-working-comments.service';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import { MomentService } from 'src/app/service/shared/moment/moment.service';

@Component({
  selector: 'app-chat-modal',
  templateUrl: './chat-modal.component.html',
  styleUrls: ['./chat-modal.component.scss'],
})
export class ChatModalComponent implements OnInit, OnChanges {
  @ViewChild('inputField') inputField: ElementRef<HTMLInputElement>
  @Input() job: any;
  @Input() commentType: any;
  @Output() printComments: EventEmitter<any> = new EventEmitter<any>();

  messagesLoaded: boolean = false;
  messages: Array<any> = [];
  newMessage: string = '';
  userId: string = '';

  constructor(
    @Inject(DOCUMENT) private _document,
    private potentialJobsWorkingCommentsService: PotentialJobsWorkingCommentsService,
    private localStorageService: LocalstorageService,
    private renderer2: Renderer2,
    private momentService: MomentService,
  ) {}

  ngOnInit(): void {
    this.userId = this.localStorageService.getItem('userId');
    this.loadScroller();
  }

  ngOnChanges(): void {
    if (this.job?.id) this.getMessages(this.job.id, this.commentType);
  }

  focusInputField() {
      const input = document.getElementById('chat-modal-text-input')
      input.focus()
  }

  //To get all potential jobs working comments
  getMessages(jobId, commentType) {
    this.messagesLoaded = false;

    //Service call to get all working comments data
    this.potentialJobsWorkingCommentsService
      .getPotentialJobsWorkingCommentsByJobId(jobId, commentType, {
        includeInvoices: 1,
      })
      .subscribe(
        res => this.onGetMessagesSuccess(res),
        error => this.onGetMessagesError(error),
      );
  }

  //On success of working status api call
  onGetMessagesSuccess(result) {
    if (result?.data) {
      this.messages = result.data;

      this.messages.forEach(msg => {
        msg.created_date = this.momentService.getGeneralDateFormat(msg.created_date, 'M/DD/YYYY h:mm A');
      });
      this.messagesLoaded = true;
      setTimeout(() => {
        this.scrollToBottom('chatBlock');
      }, 250);


      setTimeout(() => {
        this.focusInputField()
      }, 500)
    }
  }

  //On error of working wtatus api call
  onGetMessagesError(error) {}

  //To send message from chat pop up
  sendMessage() {
    if (this.newMessage && this.newMessage.trim().length > 0) {
      this.createMessage();
    }
  }

  //To get all potential jobs working comments
  createMessage() {
    this.messagesLoaded = false;
    const newMessage = {};
    newMessage['potential_job_detail_id'] = this.job.id;
    newMessage['comment'] = this.newMessage.trim();
    newMessage['user_id'] = this.userId;
    newMessage['comment_type'] = this.commentType;

    //Service call to create new working comments data
    this.potentialJobsWorkingCommentsService.createPotentialJobsWorkingComments(newMessage).subscribe(
      res => this.onMessageSaveSuccess(res),
      error => this.onMessageSaveError(error),
    );
  }

  //On success of working status api call
  onMessageSaveSuccess(result) {
    if (result) {
      if (result.data) {
        this.getMessages(this.job.id, this.commentType);
        if (!document.getElementById(this.job.id).classList.contains('danger')) {
          document.getElementById(this.job.id).classList.add('danger');
        }
        this.newMessage = '';
      }
    }
  }

  print(jobId, commentType) {
    this.printComments.emit({ jobId, commentType });
  }

  //On error of working status api call
  onMessageSaveError(error) {}

  /* JQUERY HELPER FUNCTIONS */

  loadScroller() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadScroller();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  scrollToBottom(obj) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `scrollToBottom("${obj}");`;
    this.renderer2.appendChild(this._document.body, s);
  }
}
